window.addEventListener("load", function () {
  let formArr = {
    en: "YrZb1jqINP3NTwo5_vs39Q",
    "zh-hant": "Ny94Hu1hV4XqFji0TPoVaw", //繁体
    "zh-hans": "hTZBb22F1YjsyQgChaSoIw", //簡体
  };

  let pathLang = window.location.pathname.split("/")[1];

  let formId = formArr[pathLang] || formArr["en"];
  $(".pxFormGenerator#" + formId).show();
});
